import { Box } from '@mui/material';
import { translate } from '../services';
import React from 'react';
export const CustomMessage = ( { message,color,node,icon } ) => {
  if ( message ) {
    return (
      <div className="custom-message"style={{color:color?color:'black'}}>
        <div className='message-box'>
          {icon && <Box component="img" src={icon} sx={{width:"14px", height:"14px"}}></Box>}
        {(!node) &&<span className="header" >{ translate( 'warning' ) }</span>}
          { message.split( '\n' ).map( ( l, i ) => <span className="body" key={ i }> { l } </span> ) }
        </div>
      </div>
    );
  }
  return null;
}

